var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaKnockout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Insta-knockout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Insta-knockout",
    stroke: "none",
    strokeWidth: 1,
    fill: "#00265f",
    fillRule: "evenodd",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insta",
    transform: "translate(1.470000, 1.020000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.244,14.622 C29.244,22.697 22.698,29.243 14.622,29.243 C6.547,29.243 0,22.697 0,14.622 C0,6.546 6.547,0 14.622,0 C22.698,0 29.244,6.546 29.244,14.622",
    id: "Fill-105",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.043,6.029 C20.883,6.029 23.192,8.339 23.192,11.179 L23.192,18.023 C23.192,20.863 20.883,23.173 18.043,23.173 L11.198,23.173 C8.359,23.173 6.049,20.863 6.049,18.023 L6.049,11.179 C6.049,8.339 8.359,6.029 11.198,6.029 L18.043,6.029 Z M18.043,7.642 L11.198,7.642 C9.248,7.642 7.662,9.229 7.662,11.179 L7.662,18.023 C7.662,19.974 9.248,21.56 11.198,21.56 L18.043,21.56 C19.993,21.56 21.58,19.974 21.58,18.023 L21.58,11.179 C21.58,9.229 19.993,7.642 18.043,7.642 Z M14.691,10.379 C17.02,10.379 18.913,12.273 18.913,14.601 C18.913,16.929 17.02,18.823 14.691,18.823 C12.363,18.823 10.47,16.929 10.47,14.601 C10.47,12.273 12.363,10.379 14.691,10.379 Z M14.691,11.897 C13.2,11.897 11.987,13.11 11.987,14.601 C11.987,16.092 13.2,17.306 14.691,17.306 C16.183,17.306 17.396,16.092 17.396,14.601 C17.396,13.11 16.183,11.897 14.691,11.897 Z M19.159,9.09 C19.715,9.09 20.165,9.541 20.165,10.095 C20.165,10.65 19.715,11.101 19.159,11.101 C18.605,11.101 18.154,10.65 18.154,10.095 C18.154,9.541 18.605,9.09 19.159,9.09 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaKnockout);
export default __webpack_public_path__ + "static/media/Insta-knockout.df3c400b1aa42f7842b6d68eeba53924.svg";
export { ForwardRef as ReactComponent };